import { render, staticRenderFns } from "./WebsiteItem.vue?vue&type=template&id=27b4f4c0&scoped=true&"
import script from "./WebsiteItem.vue?vue&type=script&lang=js&"
export * from "./WebsiteItem.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteItem.vue?vue&type=style&index=0&id=27b4f4c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b4f4c0",
  null
  
)

export default component.exports